import React from 'react';
import {Switch, Route, Redirect} from 'react-router-dom';
import {ThemeProvider} from '@sunbit-dev/web-ui-lib';
import LoaderContainer from './LoaderContainer';
import MainLayoutContainer from './MainLayoutContainer';
import {LoginContainer} from './LoginContainer';
import AuthProvider from './AuthProvider';

interface IAppProps {
  docsUrl: string;
}

declare const window: Window & { sunbitEnv: string, docsUrl: string };

const App = (props: IAppProps) => {

  return <ThemeProvider>
    <LoaderContainer/>
    <AuthProvider>
      {({login, logout, isLoggedIn}) => {
        return <Switch>
          <Route path="/login" render={() => <LoginContainer {...{login}}/>}/>
          <Route path="/docs" component={() => {
            window.location.href = props.docsUrl;
            return null;
          }}/>
          <Route path="/" render={() => {

            if (!isLoggedIn)
              return <Redirect to="/login"/>;

            return <MainLayoutContainer {...{logout}}/>;
          }}/>

        </Switch>
      }}
    </AuthProvider>
  </ThemeProvider>
}

export default App;
